import { ReactNode } from 'react';
import LaunchCountdown from './LaunchCountdown';

// Section 25F (the federal K-12 scholarship tax credit under the OBBBA) takes
// effect for tax year 2027 — a date fixed by statute, not per-tenant config, so
// it's hardcoded here the same way the $1,700/$3,400 credit caps are hardcoded
// constants in Donate.tsx rather than API-driven values.
const S25F_LAUNCH_DATE = '2027-01-01T00:00:00-05:00';

/**
 * Gates donate/apply content on the Section 25F launch date. Every tenant sees
 * the same countdown, because the date is federal law, not a per-org setting —
 * this stops mattering (and stops rendering anything but `children`) the moment
 * the date passes, with no config to flip.
 */
export default function S25FLaunchCountdown({
  title,
  description,
  children,
}: {
  title: string;
  description: string;
  children: ReactNode;
}) {
  return (
    <LaunchCountdown
      launchDate={S25F_LAUNCH_DATE}
      eyebrow="Section 25F · federal tax credit"
      title={title}
      description={description}
      testid="s25f-launch"
    >
      {children}
    </LaunchCountdown>
  );
}
